import serverApiV2Instance from '../../../services/serverApiV2Instance';

export const confirmRebateReceipt = (memberRebateReceiptItemId: number) =>
  serverApiV2Instance.patch(
    `/rebate-receipt-items/${memberRebateReceiptItemId}?action=fulfill`,
  );
export default confirmRebateReceipt;